<template>
  <div class="personal-m-en">
    <van-form @submit="register" class="van-form" validate-first>
      <div class="flex">
        <label class="star">English Name</label>
        <div>
          <div class="select-englishname">
            <el-select
              class="select-phone"
              v-model="datas.selectEnglishNameTitle"
              placeholder="Select"
            >
              <el-option
                v-for="(item, index) in englishNameTitle"
                :key="index"
                :value="item.title"
                :label="item.title"
              ></el-option>
            </el-select>
            <van-field
              v-model="datas.englishName"
              :rules="[{ required: true, message: 'Please input name' }]"
              class="field-phoneNumber"
            />
          </div>
        </div>
      </div>
      <div class="flex">
        <label class="star">Language</label>
        <el-select
          class="select-language"
          placeholder="Please select"
          v-model="datas.selectLanguage"
        >
          <el-option
            v-for="item in language"
            :key="item.code"
            :value="item.code"
            :label="item.enG_DESC"
          ></el-option>
        </el-select>
      </div>
      <div class="flex">
        <label class="star">Mobile No.</label>
        <div>
          <div class="select-flex">
            <el-select
              @change="getPhoneNumberCode"
              class="select-phone"
              v-model="datas.selectPhoneNumber"
              placeholder="Please select"
            >
              <el-option
                v-for="item in areaCode"
                :key="item.areaCode"
                :value="item.areaCode"
                :label="item.areaCode"
              ></el-option>
            </el-select>
            <van-field
              v-model="datas.phoneNumber"
              :rules="[
                {
                  pattern: phoneNumberPattern,
                  required: true,
                  message: phoneNumberMessage,
                },
              ]"
              class="field-phoneNumber"
            />
          </div>
        </div>
      </div>
      <div class="flex">
        <label>Home No.</label>
        <div>
          <div class="select-flex">
            <el-select
              @change="getHouseNumber"
              class="select-phone"
              v-model="datas.selectHouseNumber"
              placeholder="Please select"
            >
              <el-option
                v-for="item in areaCode"
                :key="item.areaCode"
                :value="item.areaCode"
                :label="item.areaCode"
              ></el-option>
            </el-select>
            <van-field
              type="number"
              :rules="[
                {
                  validator: validateHouseNumber,
                  message: houseNumberMessage,
                },
              ]"
              v-model="datas.houseNumber"
              class="field-phoneNumber"
            />
          </div>
        </div>
      </div>
      <div class="flex">
        <label>Email</label>
        <van-field
          :rules="[
            {
              validator: validateEmail,
              message: 'Please enter a valid email',
            },
          ]"
          v-model="datas.email"
          class="field"
        />
      </div>
      <div class="flex">
        <label class="star">Region</label>
        <el-select
          class="select-language"
          v-model="datas.selectRegion"
          filterable
          placeholder="Please select"
          no-match-text=""
          no-data-text=""
          @change="getRegionSelected"
        >
          <el-option
            v-for="item in region"
            :key="item.region_Code"
            :label="item.enG_DESC"
            :value="item.region_Code"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex">
        <label class="star">District</label>
        <el-select
          :disabled="datas.selectRegion === ''"
          class="select-language"
          v-model="datas.selectDistrict"
          filterable
          placeholder=""
          no-match-text=""
          no-data-text=""
          @change="getDistrictSelected"
        >
          <el-option
            v-for="item in filterDistrict"
            :key="item.districtCode"
            :label="item.district_EName"
            :value="item.districtCode"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex" style="align-items: flex-start">
        <label class="star" for="">Delivery Address</label>
        <van-field
          class="field"
          type="textarea"
          placeholder="Address1"
          v-model="datas.address1"
          :rules="[
            { required: true, message: 'Please input delivery address' },
          ]"
        ></van-field>
      </div>
      <div class="flex">
        <label></label>
        <van-field
          class="field"
          type="textarea"
          placeholder="Address2"
          v-model="datas.address2"
        ></van-field>
      </div>
      <div class="flex">
        <van-checkbox
          checked-color="#999"
          @change="clearContact"
          v-model="datas.checked"
          shape="square"
          >Delivery Contact Same as Customer Contact</van-checkbox
        >
      </div>
      <div class="flex-bottom">
        <label style="display:inline-block;width:230px;" :class="datas.checked ? '' : 'star'"
          >Delivery Contact English Name</label
        >
        <el-select
          style="width: 123px"
          :disabled="datas.checked"
          class="select-phone"
          v-model="datas.title"
          placeholder="Select"
        >
          <el-option
            v-for="item in englishNameTitle"
            :key="item.id"
            :value="item.title"
            :label="item.title"
          >
          </el-option>
        </el-select>
        <van-field
          :disabled="datas.checked"
          v-model="datas.contact_Ename"
          class="field"
          :rules="[
            {
              required: true,
              message: 'Please input name',
            },
          ]"
        />
      </div>
      <div class="flex-bottom">
        <!-- delivery:送货 -->
        <label style="display:inline-block;width:190px;" :class="datas.checked ? '' : 'star'"
          >Delivery Contact Language</label
        >
        <el-select
          :disabled="datas.checked"
          class="select-contact-language"
          v-model="datas.Address_Language"
          placeholder="Select"
        >
          <el-option
            v-for="item in language"
            :key="item.code"
            :value="item.code"
            :label="item.enG_DESC"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-bottom">
        <label :class="datas.checked ? '' : 'star'"
          >Delivery Contact Mobile No.</label
        >
        <div>
          <div class="select-flex">
            <el-select
              :disabled="datas.checked"
              @change="getContactPhone"
              class="select-phone"
              v-model="datas.contact_Mobile_Coun_Code"
              placeholder="Select"
            >
              <el-option
                v-for="item in areaCode"
                :key="item.areaCode"
                :value="item.areaCode"
                :label="item.areaCode"
              ></el-option>
            </el-select>
            <van-field
              :disabled="datas.checked"
              v-model="datas.contact_Mobile"
              class="field-phoneNumber"
              type="number"
              :rules="[
                {
                  pattern: contactPhoneParrent,
                  required: true,
                  message: contactPhoneMessage,
                },
              ]"
            />
          </div>
        </div>
      </div>
      <!-- <div class="tips" style="font-size: 16px;">
        The personal data we collect will only be transferred to third-party delivery company for home delivery purposes. If you need to further understand APITA/UNY Privacy Policy and Personal Data Collection Statement, please kindly visit the website below:
        <br>
        <el-link style="font-size: 14px;" :underline="false" type="primary" target="_blank" href="https://apitauny.com.hk/privacy-notice/?lang=en">https://apitauny.com.hk/privacy-notice/?lang=en</el-link>
      </div> -->
      <div class="tips" style="font-size: 16px;">
        The personal data we collect will only be transferred to third-party delivery company for home delivery purposes. If you need to further understand Citistore Privacy Policy and Personal Data Collection Statement, please kindly visit the website below:
        <br>
        <el-link style="font-size: 14px;" :underline="false" type="primary" target="_blank" href="https://www.citistore.com.hk/en/privacy_policy_chi/">https://www.citistore.com.hk/en/privacy_policy_chi/</el-link>
      </div>
      <div class="btn">
        <van-button
          native-type="button"
          @click="clear()"
          type="default"
          style="width: 70px; height: 35px; background-color: #f1f1f1; font-size: 16px;"
          class="left-btn"
          size="normal"
          >Clear</van-button
        >
        <van-button
          native-type="submit"
          type="primary"
          style="width: 70px; height: 35px;text-align:center;font-size: 16px;"
          size="normal"
          >Register</van-button
        >
      </div>
    </van-form>

    <div v-if="isShow" id="imgver"></div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import {
  getAreaCode,
  getDistrict,
  getLanguage,
  getRegion,
  customerRegister,
} from "@/api/index.js";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      getAreaCode,
      getDistrict,
      getLanguage,
      getRegion,
      customerRegister,
      isShow: true,
      datas: {
        selectEnglishNameTitle: "",
        englishName: "",
        selectLanguage: undefined,
        selectPhoneNumber: undefined,
        phoneNumber: "",
        selectHouseNumber: undefined,
        houseNumber: "",
        email: "",
        selectRegion: "",
        selectDistrict: "",
        checked: true,
        title: "",
        contact_Name: "",
        contact_Ename: "",
        Address_Language: "",
        contact_Mobile_Coun_Code: undefined,
        contact_Mobile: "",
        address1: "",
        address2: "",
      },
      englishNameTitle: [
        { title: "Mr", id: 0 },
        { title: "Mrs", id: 1 },
        { title: "Ms", id: 2 },
      ],
      phoneNumberPattern: /^\d{8}$/,
      houseNumberPattern: /^\d{8}$/,
      contactPhoneParrent: /^\d{8}$/,
      phoneNumberMessage: "Please input 8 digits phone no.",
      houseNumberMessage: "Please input 8 digits phone no.",
      contactPhoneMessage: "Please input 8 digits phone no.",
      areaCode: [],
      // 筛选完的District数据
      filterDistrict: [],
      // 初始未筛选的District数据
      district: [],
      language: [],
      region: [],
    };
  },
  methods: {
    /**
     * 登记方法
     */
    register() {
      this.$imgVer({
        el: '$("#imgver")',
        width: "260",
        height: "116",
        img: [
          require("@/assets/images/imgver/ver-1.png"),
          require("@/assets/images/imgver/ver-2.png"),
          require("@/assets/images/imgver/ver-3.png"),
          require("@/assets/images/imgver/ver-4.png"),
          require("@/assets/images/imgver/ver-5.png"),
          require("@/assets/images/imgver/ver-6.png"),
        ],
        lan: "en", //'cn' or 'en'
        success: () => {
          this.goRegister();
          setTimeout(() => {
            this.isShow = false;
          }, 500);
          setTimeout(() => {
            this.isShow = true;
          }, 1000);
        },
        error: function () {
          return false;
        },
      });
    },

    goRegister() {
      let query = {
        appkey: "HD123456",
        secretkey: "HD123456",
        create_Platform: "MOBILE",
        customer_title: this.datas.selectEnglishNameTitle,
        customer_Name: "",
        customer_Ename: this.datas.englishName,
        company_Name: "",
        language: this.datas.selectLanguage,
        home_Tel: this.datas.houseNumber,
        mobile: this.datas.phoneNumber,
        email: this.datas.email,
        home_Coun_Code: this.datas.selectHouseNumber,
        mobile_Coun_Code: this.datas.selectPhoneNumber,
        contact_Name: "",
        contact_Ename: this.datas.contact_Ename,
        E_ADDRESS1: this.datas.address1,
        E_ADDRESS2: this.datas.address2,
        region_Code: this.datas.selectRegion,
        district_Code: this.datas.selectDistrict,
        contact_Mobile: this.datas.contact_Mobile,
        contact_Mobile_Coun_Code: this.datas.contact_Mobile_Coun_Code,
        Is_Same: this.datas.checked ? 1 : 0,
        Title: this.datas.title,
        Address_Language: this.datas.Address_Language,
        CREATE_PLATFORM: "MOBILE",
      };
      this.customerRegister(query).then((res) => {
        if (res.status === 200 && res.data.resultCode === "Success") {
          Dialog.alert({
            message: "Registration succeeded!",
            confirmButtonText: "OK",
            confirmButtonColor: "#07c160",
          }).then(() => {});
          this.datas.englishName = "";
          this.datas.selectEnglishNameTitle = "";
          this.datas.phoneNumber = "";
          this.datas.houseNumber = "";
          this.datas.email = "";
          this.datas.selectRegion = "";
          this.datas.selectDistrict = "";
          this.datas.title = undefined;
          this.datas.contact_Ename = "";
          this.datas.contact_Mobile = "";
          this.datas.contact_Mobile_Coun_Code = undefined;
          this.datas.address1 = "";
          this.datas.address2 = "";
        } else {
          setTimeout(() => {
            Toast("Registration timed out, please try again!");
          }, 5000);
        }
      });
    },

    //清除
    clear() {
      Dialog.confirm({
        message: "Confirm to clear all information?",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: "#07c160",
        className: "van-dialog__message",
      })
        .then(() => {
          // on confirm
          this.datas.englishName = "";
          this.datas.selectEnglishNameTitle = "";
          this.datas.phoneNumber = "";
          this.datas.houseNumber = "";
          this.datas.email = "";
          this.datas.selectRegion = "";
          this.datas.selectDistrict = "";
          this.datas.title = undefined;
          this.datas.contact_Ename = "";
          this.datas.contact_Mobile = "";
          this.datas.Address_Language = "";
          this.datas.contact_Mobile_Coun_Code = undefined;
          this.datas.address1 = "";
          this.datas.address2 = "";
          setTimeout(() => {
            Toast("Cleared successfully!");
          }, 1000);
        })
        .catch(() => {
          // on cancel
        });
    },

    /**
     * 监听选中的areaCode
     */
    getPhoneNumberCode() {
      if (this.datas.checked) {
        if (this.datas.selectPhoneNumber === "+852") {
          this.phoneNumberPattern = /^\d{8}$/;
          this.phoneNumberMessage = "Please input 8 digits phone no.";

          this.contactPhoneParrent = /^\d{8}$/;
          this.contactPhoneMessage = "Please input 8 digits phone no.";
        } else if (this.datas.selectPhoneNumber === "+853") {
          this.phoneNumberPattern = /^\d{8}$/;
          this.phoneNumberMessage = "Please input 8 digits phone no.";

          this.contactPhoneParrent = /^\d{8}$/;
          this.contactPhoneMessage = "Please input 8 digits phone no.";
        } else if (this.datas.selectPhoneNumber === "+86") {
          this.phoneNumberPattern = /^\d{11}$/;
          this.phoneNumberMessage = "Please input 11 digits phone no.";

          this.contactPhoneParrent = /^\d{11}$/;
          this.contactPhoneMessage = "Please input 11 digits phone no.";
        }
      }

      if (!this.datas.checked) {
        if (this.datas.selectPhoneNumber === "+852") {
          this.phoneNumberPattern = /^\d{8}$/;
          this.phoneNumberMessage = "Please input 8 digits phone no.";
        } else if (this.datas.selectPhoneNumber === "+853") {
          this.phoneNumberPattern = /^\d{8}$/;
          this.phoneNumberMessage = "Please input 8 digits phone no.";
        } else if (this.datas.selectPhoneNumber === "+86") {
          this.phoneNumberPattern = /^\d{11}$/;
          this.phoneNumberMessage = "Please input 11 digits phone no.";
        }
      }
    },
    /**
     * 家庭电话正则
     */
    getHouseNumber() {
      if (this.datas.selectHouseNumber === "+852") {
        this.houseNumberPattern = /^\d{8}$/;
        this.houseNumberMessage = "Please input 8 digits phone no.";
        console.log(this.houseNumberPattern);
      } else if (this.datas.selectHouseNumber === "+853") {
        this.houseNumberPattern = /^\d{8}$/;
        this.houseNumberMessage = "Please input 8 digits phone no.";
      } else if (this.datas.selectHouseNumber === "+86") {
        this.houseNumberPattern = /^\d{11}$/;
        this.houseNumberMessage = "Please input 11 digits phone no.";
      }
    },

    getContactPhone() {
      if (!this.datas.checked) {
        if (this.datas.contact_Mobile_Coun_Code === "+852") {
          this.contactPhoneParrent = /^\d{8}$/;
          this.contactPhoneMessage = "Please input 8 digits phone no.";
        } else if (this.datas.contact_Mobile_Coun_Code === "+853") {
          this.contactPhoneParrent = /^\d{8}$/;
          this.contactPhoneMessage = "Please input 8 digits phone no.";
        } else if (this.datas.contact_Mobile_Coun_Code === "+86") {
          this.contactPhoneParrent = /^\d{11}$/;
          this.contactPhoneMessage = "Please input 11 digits phone no.";
        }
      }
    },

    getRegionSelected() {
      this.datas.selectDistrict = "";
      this.filterDistrict = [];
      this.district.filter((item) => {
        if (this.datas.selectRegion === item.regionCode.slice(0, 2)) {
          console.log(this.datas.selectRegion);
          this.filterDistrict.push(item);
          return;
        } else if (this.datas.selectRegion === item.regionCode) {
          this.filterDistrict.push(item);
          return;
        }
      });
    },
    getDistrictSelected() {},
    /**
     * checked為false 清空contact資料
     */
    clearContact() {
      if (!this.datas.checked) {
        this.datas.contact_Ename = "";
        this.datas.contact_Mobile = "";
        this.datas.title = "";
        this.areaCode.forEach((item) => {
          if (item.isdefault === 1) {
            this.datas.contact_Mobile_Coun_Code = item.areaCode;
          }
          this.language.forEach((item) => {
            if (item.isdefault === 1) {
              this.datas.Address_Language = item.code;
            }
          });
        });
      }
    },
    validateHouseNumber(value, rule) {
      if (value) {
        // return true;
        if (this.datas.selectHouseNumber === "+852") {
          return /^\d{8}$/.test(value);
        } else if (this.datas.selectHouseNumber === "+853") {
          return /^\d{8}$/.test(value);
        } else if (this.datas.selectHouseNumber === "+86") {
          return /^\d{11}$/.test(value);
        }
      }
      return true;
    },
    validateEmail(value, rule) {
      if (value) {
        return /(?=^.{3,256}$)^([\w\-]+([\.][\w\-]+)*)@[a-zA-Z0-9][a-zA-Z0-9\-\.]*[\.][A-Za-z]{2,6}$/.test(value)
      }
      return true;
    },
  },
  created() {
    let query = {
      appkey: "HD123456",
      secretkey: "HD123456",
    };
    this.getAreaCode(query).then((result) => {
      this.areaCode = result.data.areaCode;
      this.areaCode.forEach((item) => {
        if (item.isdefault === 1) {
          this.datas.selectPhoneNumber = item.areaCode;
          this.datas.selectHouseNumber = item.areaCode;
          this.datas.contact_Mobile_Coun_Code = item.areaCode;
        }
      });
    });
    this.getDistrict(query).then((result) => {
      this.district = result.data.district;
    });
    this.getLanguage(query).then((result) => {
      this.language = result.data.language;
      this.language.forEach((item) => {
        if (item.isdefault === 1) {
          this.$nextTick(() => {
            this.datas.selectLanguage = item.code;
            this.datas.Address_Language = item.code;
          });
          return;
        } else if (this.datas.selectRegion === item.regionCode) {
          this.filterDistrict.push(item);
          return;
        }
      });
    });
    this.getRegion(query).then((result) => {
      this.region = result.data.region;
    });
  },

  mounted() {
    if (
      !!this.datas.selectLanguage ||
      !!this.datas.selectPhoneNumber ||
      !!this.datas.selectHouseNumber ||
      !!this.datas.selectRegion ||
      !!this.datas.selectDistrict
    ) {
      window.location.reload();
    }
  },

  updated() {
    /**
     * contact 与 customer
     */
    if (this.datas.checked) {
      this.datas.title = this.datas.selectEnglishNameTitle;
      this.datas.contact_Ename = this.datas.englishName;
      this.datas.Address_Language = this.datas.selectLanguage;
      this.datas.contact_Mobile_Coun_Code = this.datas.selectPhoneNumber;
      this.datas.contact_Mobile = this.datas.phoneNumber;
    }
  },
};
</script>

<style lang="scss">
.van-dialog__message {
  font-size: 17px !important;
  padding: 0 !important;
}
.van-field__control {
  font-size: 16px;
}
.personal-m-en {
  width: 95%;
  height: 100vh;
  font-size: 0.7em;
  padding: 0 auto;
  .van-form {
    padding: 10px 0 0 3%;
    align-items: center;
    .flex-bottom {
      display: flex;
      font-size: 16px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      border-bottom: 1px solid #e5e5e5;
      padding: 6px;
      .star::after {
        content: "*";
        color: #f00;
        margin-left: 6px;
      }
      .field {
        width: 174px;
        font-size: 0.8em;
        padding: 0;
      }

      .select-language {
        width: 187px;
        border: 0;
        padding: 3px 0;
      }
      .select-contact-language {
        width: 245px;
        border: 0;
      }
      .select-language:active {
        border: 0;
      }
      .select-englishname {
        width: 187px;
        display: flex;
        align-items: center;
        .select-phone {
          border: 0;
        }
        .field-phoneNumber {
          padding: 0 0 0 8px;
        }
      }
      .select-flex {
        width: 190px;
        display: flex;
        align-items: center;
        .select-phone {
          border: 0;
        }
        .field-phoneNumber {
          padding: 0 0 0 5px;
        }
      }
    }
    .flex {
      display: flex;
      flex-direction: row;
      font-size: 16px;
      line-height: 30px;
      justify-content: space-between;
      background-color: #fff;
      border-bottom: 1px solid #e5e5e5;
      padding: 6px;
      .star::after {
        content: "*";
        color: #f00;
        margin-left: 6px;
      }
      .field {
        width: 174px;
        padding: 0;
      }

      .select-language {
        width: 187px;
        border: 0;
        padding: 3px 0;
      }
      .select-contact-language {
        width: 240px;
        border: 0;
      }
      .select-language:active {
        border: 0;
      }
      .select-englishname {
        width: 187px;
        display: flex;
        align-items: center;
        .select-phone {
          border: 0;
        }
        .field-phoneNumber {
          padding: 0 0 0 8px;
        }
      }
      .select-flex {
        width: 190px;
        display: flex;
        align-items: center;
        .select-phone {
          border: 0;
        }
        .field-phoneNumber {
          padding: 0 0 0 5px;
        }
      }
    }
  }
  .btn {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 30px;
    padding-bottom: 20px;
    .left-btn {
      background-color: #f1f1f1;
    }
  }
  .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border: none;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: 16px;
    height: 18px;
    line-height: 18px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .el-input {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .el-input__icon {
    height: 100%;
    width: 25px;
    text-align: center;
    transition: all 0.3s;
    line-height: 18px;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed;
  }
}
</style>
